import { render, staticRenderFns } from "./MCrop.vue?vue&type=template&id=035d996a"
import script from "./MCrop.vue?vue&type=script&lang=js"
export * from "./MCrop.vue?vue&type=script&lang=js"
import style0 from "./MCrop.vue?vue&type=style&index=0&id=035d996a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports